import script from "./TariffBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffBlock.vue?vue&type=script&setup=true&lang=js"

import "./TariffBlock.vue?vue&type=style&index=0&id=512dc52e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512dc52e"]])

export default __exports__